import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Compass, Eye } from "lucide-react";
import { Reveal, SectionHead } from "./Reveal";
import { QUIENES_SOMOS } from "../data/content";

export const QuienesSomos = () => {
  const imgRef = useRef(null);
  const { scrollYProgress } = useScroll({ target: imgRef, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [-36, 36]);

  return (
    <section
      id="quienes-somos"
      data-testid="quienes-somos-section"
      className="relative bg-white py-20 sm:py-28 lg:py-36"
    >
      <div className="mx-auto grid max-w-7xl grid-cols-12 gap-12 px-4 sm:px-6 lg:px-8">
        <div className="col-span-12 lg:col-span-7">
          <SectionHead num="01" eyebrow="La empresa" title={QUIENES_SOMOS.title} testId="quienes-somos-head" />
          <Reveal delay={0.15}>
            <p className="font-bodoni mt-8 max-w-2xl text-lg leading-relaxed text-cafe-muted sm:text-xl">
              {QUIENES_SOMOS.text}
            </p>
          </Reveal>

          <div className="mt-14 grid gap-6 sm:grid-cols-2">
            <Reveal delay={0.1}>
              <article
                data-testid="mision-card"
                className="group h-full border-l-2 border-cafe bg-cream p-7 transition-colors duration-500 hover:bg-cafe-soft"
              >
                <Compass className="h-6 w-6 text-cafe transition-transform duration-500 group-hover:-rotate-12" />
                <h3 className="mt-5 font-display text-2xl font-semibold text-cafe-dark">
                  Nuestra Misión
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-cafe-muted">{QUIENES_SOMOS.mision}</p>
              </article>
            </Reveal>
            <Reveal delay={0.2}>
              <article
                data-testid="vision-card"
                className="group h-full border-l-2 border-cafe-dark bg-cream p-7 transition-colors duration-500 hover:bg-cafe-soft"
              >
                <Eye className="h-6 w-6 text-cafe-dark transition-transform duration-500 group-hover:scale-110" />
                <h3 className="mt-5 font-display text-2xl font-semibold text-cafe-dark">
                  Nuestra Visión
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-cafe-muted">{QUIENES_SOMOS.vision}</p>
              </article>
            </Reveal>
          </div>
        </div>

        <div className="col-span-12 lg:col-span-5" ref={imgRef}>
          <Reveal delay={0.2} className="relative mt-4 lg:mt-24">
            <div aria-hidden="true" className="absolute -left-4 -top-4 h-full w-full border border-cafe" />
            <div className="relative overflow-hidden">
              <motion.img
                style={{ y, scale: 1.12 }}
                src="/img/quienes-somos.webp"
                alt="Colado de concreto y cimbra en obra de OESCA"
                data-testid="quienes-somos-image"
                className="h-[380px] w-full object-cover sm:h-[480px]"
              />
            </div>
            <p className="mt-4 border-t border-cafe-line pt-3 font-mono text-[10px] uppercase tracking-[0.3em] text-cafe-muted">
              Cimentación — ejecución en sitio
            </p>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
